import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import React from 'react'

const VerificationMethodBox = ({ mainIcon, btnIcon, btnLabel, headeing, subHeading, onClick }) => {
    return (
        <div className="p-4 border rounded-lg border-zinc-500">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    {mainIcon}
                    <div>
                        <h3 className="font-semibold text-neutral-900">{headeing}</h3>
                        <p className="text-sm text-neutral-600">{subHeading}</p>
                    </div>
                </div>
                <div className="flex gap-2">
                    <CustomButtonNew onClick={onClick} prefixIcon={btnIcon} label={btnLabel} className="text-white bg-primary" />
                </div>
            </div>
        </div>
    )
}

export default VerificationMethodBox